export default __webpack_public_path__ + "5a4b48e99b1d05bb310c9e3cb3850832.png";